<template>
  <div :class="{'hideleft':hide === true}" class="page">
    <div class="crumb-container">
      <ol class="breadcrumb">
        <li>
          <a href="javascript:;" class="crumb-home z-font-size-14">账户</a>
        </li>
        <li>
          <a href="javascript:;" class="z-font-size-14">绑定手机</a>
        </li>
      </ol>
    </div>
    <div class="page-main z-padding-h-20-precent">
      <div class="panel-heading">
        <div class="panel-title">绑定手机</div>
      </div>
      <div class="panel-body">
        <div v-if="userPhone" class="yancontant ub-box ub-col">
          <div class="licontant ub-box ub-between z-box-sizing">
            <div class="ub-box z-relative">
              <i class="iconfont icon-circle-check z-absolute z-font-size-25"></i>
              <span class="z-font-size-20 z-padding-left-50-precent z-lineHeight-39">您已绑定手机{{userphone}}，是否要修改绑定？</span>
            </div>
            <div class="z-padding-top-10-precent z-padding-right-30-precent">
              <xbutton font="立即修改" type="yanzheng" @XbuttonService="changePhone"/>
            </div>
          </div>
        </div>
        <div v-if="alert" class="alert-warn margin-bottom-20">
          您正在为账户{{username}}修改绑定，请耐心完成下面操作
        </div>
        <div v-if="checkbox" class="yancontant ub-box ub-col">
          <div v-if="isMobile" class="licontant ub-box ub-between z-box-sizing">
            <div class="ub-box">
              <div class="iconimg"></div>
              <div class="z-margin-left-15-precent">
                <div class="z-font-size-20 z-lineHeight-24">通过手机验证</div>
                <div class="z-font-size-14 z-color-999">如果您的手机还在正常使用，请选择此方式</div>
              </div>
            </div>
            <div class="z-padding-top-10-precent z-padding-right-30-precent">
              <xbutton font="立即验证" type="yanzheng" @XbuttonService="checkUsePhone"/>
            </div>
          </div>
          <div v-if="isEmail" class="licontant ub-box ub-between z-box-sizing">
            <div class="ub-box">
              <div class="iconimg email"></div>
              <div class="z-margin-left-15-precent">
                <div class="z-font-size-20 z-lineHeight-24">通过邮箱验证</div>
                <div class="z-font-size-14 z-color-999">如果您的邮箱还在正常使用，请选择此方式</div>
              </div>
            </div>
            <div class="z-padding-top-10-precent z-padding-right-30-precent">
              <xbutton font="立即验证" type="yanzheng" @XbuttonService="checkUseEmail"/>
            </div>
          </div>
          <div v-if="isMobile" class="licontant ub-box ub-between z-box-sizing">
            <div class="ub-box">
              <div class="iconimg men"></div>
              <div class="z-margin-left-15-precent">
                <div class="z-font-size-20 z-lineHeight-24">通过人工服务</div>
              </div>
            </div>
            <div class="z-padding-top-10-precent z-padding-right-30-precent">
              <xbutton font="立即验证" type="yanzheng" @XbuttonService="checkUseKefu"/>
            </div>
          </div>
        </div>
        <div v-if="step" class="step z-margin-top-30-precent">
          <div class="steps">
            <p :class="{'step-ed':steps === 1,'step-wu':steps != 1}">1</p>
            <p :class="{'z-color-orange':steps === 1,'z-color-gray':steps != 1}" class="text">验证身份</p>
          </div>
          <div class="stepload"></div>
          <div class="steps">
            <p :class="{'step-ed':steps === 2,'step-wu':steps != 2}">2</p>
            <p :class="{'z-color-orange':steps === 2,'z-color-gray':steps != 2}" class="text">修改手机</p>
          </div>
          <div class="stepload"></div>
          <div class="steps">
            <p :class="{'step-check-succ':steps === 3,'step-check':steps != 3}">.</p>
            <p :class="{'z-color-orange':steps === 3,'z-color-gray':steps != 3}" class="text">完成</p>
          </div>
        </div>
        <div v-if="checkphone" class="check-phone1">
          <div class="z-padding-top-30-precent z-font-size-14">
            <span class="iconi z-margin-right-5-precent"></span>
            您正在使用  验证身份，请完成以下操作
          </div>
          <div class="phone-caozuo">
            <div class="caozuo">
              <div class="caozuo-left">手机号码：</div>
              <div class="caozuo-right">{{userphone}}</div>
            </div>
            <div class="caozuo">
              <div class="caozuo-left">验证码：</div>
              <div class="caozuo-right">
                <input type="text" v-model="checkstep1.code" class="yanzhengma" placeholder="6位数">
                <button :disabled="pcodebtn" class="getyan z-color-red" @click="gotPCode">{{pcodetxt}}</button>
              </div>
            </div>
            <div class="caozuo">
              <div class="caozuo-left"></div>
              <div class="caozuo-right">
                <xbutton font="确定" type="change" @XbuttonService="checkPCode"/>
              </div>
            </div>
          </div>
        </div>
        <div v-if="checkemail" class="check-phone1">
          <div class="z-padding-top-30-precent z-font-size-14">
            <span class="iconi z-margin-right-5-precent"></span>
            您正在使用  验证身份，请完成以下操作
          </div>
          <div class="phone-caozuo">
            <div class="caozuo">
              <div class="caozuo-left">邮箱：</div>
              <div class="caozuo-right">{{useremail}}</div>
            </div>
            <div class="caozuo">
              <div class="caozuo-left">验证码：</div>
              <div class="caozuo-right">
                <input type="text" v-model="checkstep1.code" class="yanzhengma" placeholder="6位数">
                <button :disabled="ecodebtn" class="getyan z-color-red" @click="gotECode">{{ecodetxt}}</button>
              </div>
            </div>
            <div class="caozuo">
              <div class="caozuo-left"></div>
              <div class="caozuo-right">
                <xbutton font="确定" type="change" @XbuttonService="checkECode"/>
              </div>
            </div>
          </div>
        </div>
        <div v-if="checkStep2 || allNone" class="check-phone1">
          <div class="z-padding-top-30-precent z-font-size-14">
            <span class="iconi z-margin-right-5-precent"></span>
            我们不会泄露您的手机信息
          </div>
          <div class="phone-caozuo">
            <div class="caozuo">
              <div class="caozuo-left">手机号码：</div>
              <div class="caozuo-right">
                <input type="text" v-model="checkstep2.phone" class="yanzhengma">
              </div>
            </div>
            <div class="caozuo">
              <div class="caozuo-left">验证码：</div>
              <div class="caozuo-right">
                <input type="text" v-model="checkstep2.code" class="yanzhengma" placeholder="6位数">
                <button :disabled="ncodebtn" class="getyan z-color-red" @click="gotNewCode">{{ncodetxt}}</button>
              </div>
            </div>
            <div class="caozuo">
              <div class="caozuo-left"></div>
              <div class="caozuo-right">
                <xbutton font="确定" type="change" @XbuttonService="checkNewCode"/>
              </div>
            </div>
          </div>
        </div>
        <div v-if="checkStep3" class="check-phone1">
          <div class="z-padding-top-30-precent z-font-size-14">
            绑定手机成功
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  /*import userService from 'business/userService.js'*/
  import { MessageBox } from 'element-ui';
  import Xbutton from 'commons/Xbutton.vue'
  import userService from 'business/userService.js'
  import updatePasswordService from 'business/updatePasswordService.js'
  export default {
    data () {
      return {
        alert:false,
        userPhone:false,
        checkbox:false,
        isMobile:false,
        isEmail:false,
        allNone:false,
        step:false,
        steps:1,
        checkphone:false,
        checkemail:false,
        checkStep2:false,
        checkStep3:false,
        pcodebtn:false,
        ecodebtn:false,
        ncodebtn:false,
        pcodetxt:'免费获取验证码',
        ecodetxt:'免费获取验证码',
        ncodetxt:'免费获取验证码',
        ptime:60,
        etime:60,
        ntime:60,
        userphone:'',
        useremail:'',
        username:'',
        checkstep1:{
          code:''
        },
        checkstep2:{
          phone:'',
          code:''
        }
      }
    },
    components: {
      Xbutton
    },
    props:{
      hide:Boolean
    },
    mounted(){
      this.getAllUser('userInfo','cmd=userinfo')
    },
    methods: {
      async getAllUser(urlType,data) {
        let {vueData, state} = await userService.transformToVue(urlType,'POST',data)
        if(state.code === '000' ) {
          let msg = vueData.msg
          this.userPhone = msg.ID_Mobile ? true : false
          this.checkbox = msg.ID_Mobile ? false : true
          this.isMobile = msg.ID_Mobile ? true : false
          this.isEmail = msg.ID_Email ? true : false
          this.allNone = msg.ID_Mobile ? false : true
          this.userphone = msg.ID_Mobile
          this.useremail = msg.ID_Email
          this.username = msg.username
        }else {
          this.$toast({tip:'请刷新页面...',type:'3'})
        }
      },
      changePhone(){
        this.userPhone = false
        this.checkbox = true
        this.alert = true
      },
      checkUsePhone(){
        this.checkbox = false
        this.step = true
        this.checkphone = true
      },
      checkUseEmail(){
        this.checkbox = false
        this.step = true
        this.checkemail = true
      },
      checkUseKefu(){
        const h = this.$createElement;
        MessageBox({
          title: '提示信息',
          message: h('p', null, [
            h('a', {
              attrs: {
                'href': '/help/content_1107.html',
                'class': 'z-color-link z-font-size-14',
                'target': '_blank'
              }
            }, '账号申诉')
          ]),
          confirmButtonText: '确定',
          lockScroll: false,
        });
      },
      async gotPCode(){
        let {vueData, state} = await updatePasswordService.sendCode('sendCode' ,'cmd=send_yzm_mobile')
        if(vueData.response == 200 ) {
          this.$toast(vueData.msg,'warn')
          this.pstart()
        }else {
          this.$toast(vueData.msg,'warn')
        }
      },
      pstart () {
        var _this = this
        if (this.ptime > 0) {
          this.pcodebtn = true
          this.ptime = this.ptime -1
          this.pcodetxt = this.ptime + "秒后重新发送"
          let timer = setTimeout(function () {
            _this.pstart()
          }, 1000);
        } else {
          this.pcodebtn = false
          this.pcodetxt = '再次发送验证码'
          this.ptime = 60;
        }
      },
      estart () {
        var _this = this
        if (this.etime > 0) {
          this.ecodebtn = true
          this.etime = this.etime -1
          this.ecodetxt = this.etime + "秒后重新发送"
          let timer = setTimeout(function () {
            _this.estart()
          }, 1000);
        } else {
          this.ecodebtn = false
          this.ecodetxt = '再次发送验证码'
          this.etime = 60;
        }
      },
      nstart () {
        var _this = this
        if (this.ntime > 0) {
          this.ncodebtn = true
          this.ntime = this.ntime -1
          this.ncodetxt = this.ntime + "秒后重新发送"
          let timer = setTimeout(function () {
            _this.nstart()
          }, 1000);
        } else {
          this.ncodebtn = false
          this.ncodetxt = '再次发送验证码'
          this.ntime = 60;
        }
      },
      async gotECode(){
        let {vueData, state} = await updatePasswordService.sendCode('sendCode' ,'cmd=send_yzm_email')
        if(vueData.response == 200 ) {
          this.$toast(vueData.msg,'warn')
          this.estart()
        }else {
          console.log(vueData)
          this.$toast(vueData.msg,'warn')
        }
      },
      async checkPCode(){
        let data = 'cmd=check_user_verify'+'&yzm='+this.checkstep1.code
        let {vueData, state} = await updatePasswordService.sendCode('sendCode' ,data)
        if(vueData.response == 200 ) {
          this.checkphone = false
          this.checkStep2 = true
          this.steps = 2
        }else {
          this.$toast(vueData.msg,'warn')
        }
      },
      async checkECode(){
        let data = 'cmd=check_user_verify'+'&yzm='+this.checkstep1.code
        let {vueData, state} = await updatePasswordService.sendCode('sendCode' ,data)
        if(vueData.response == 200 ) {
          this.checkemail = false
          this.checkStep2 = true
          this.steps = 2
        }else {
          this.$toast(vueData.msg,'warn')
        }
      },
      async gotNewCode(){
        let data = 'cmd=send_yzm_new_mobile'+'&new_mobile='+this.checkstep2.phone
        let {vueData, state} = await updatePasswordService.sendCode('sendCode' ,data)
        if(vueData.response == 200 ) {
          this.$toast(vueData.msg,'warn')
          this.nstart()
        }else {
          this.$toast(vueData.msg,'warn')
        }
      },
      async checkNewCode(){
        let data = 'cmd=bind_new_mobile'+'&new_mobile_yzm='+this.checkstep2.code
        let {vueData, state} = await updatePasswordService.sendCode('sendCode' ,data)
        if(vueData.response == 200 ) {
          this.checkStep2 = false
          this.checkStep3 = true
          this.steps = 3

        }else {
          this.$toast(vueData.msg,'warn')
        }
      }
    }
  }
</script>
<style scoped>
  .hideleft { margin-left: 80px; }
  a {
    text-decoration: none;
  }
  .crumb-home {
    padding-left: 28px;
    background: url(../../assets/imgs/zhanghu.png) no-repeat left center;
  }
  .alert-warn {
    margin-bottom: 30px;
  }
  .yancontant {
    width: 95%;
    color: #666;
  }
  .licontant {
    width: 100%;
    height: 90px;
    border: 1px solid #e9e9e9;
    box-shadow: 0 0 5px #e9e9e9;
    margin-bottom: 20px;
    padding: 20px 0;
    transition:background-color ease-in .2s;
  }
  .yancontant .licontant .iconimg {
    display: inline-block;
    width: 40px;
    height: 47px;
    margin-left: 30px;
    background: url(../../assets/imgs/phonePeople.png) no-repeat;
  }
  .yancontant .licontant .men { background-position: -54px; }
  .yancontant .licontant .email { background-position: -104px; }
  .yancontant .licontant:hover{background:#f7f9fc;border-color:#91b3cd;}
  .icon-circle-check {
    left: 30px;
    top: 10px;
    font-size: 23px;
    color: #0099cc;
  }
  .z-lineHeight-39 { line-height: 3.9rem; }

  /*更改*/
  .step {
    width: 990px;
  }
  .step .steps {
    width: 60px;
    height: 60px;
    position: relative;
  }
  .step div {
    display: inline-block;
    padding: 0;
    margin: 0;
  }
  .step-ed {
    background: url(../../assets/imgs/step.png) no-repeat -30px;
  }
  .step-wu {
    background-image: url(../../assets/imgs/step.png);
    background-position: 0;
  }
  .step-check {
    width: 30px;
    background-image: url(../../assets/imgs/icon.png);
    background-position: -68px;
  }
  .step-check-succ {
    width: 30px;
    background-image: url(../../assets/imgs/icon.png);
    background-position: -170px;
  }
  .step-ed, .step-wu, .step-check, .step-check-succ {
    width: 30px;
    height: 30px;
    margin-left: 15px;
    color: #fff;
    text-align: center;
    line-height: 30px;
  }
  .step .steps .text {
    position: absolute;
    bottom: 0;
    width: 60px;
    text-align: center;
    font-weight: 700;
  }
  .step .stepload {
    width: 295px;
    height: 3px;
    background: #b9b9b9;
  }
  .iconi {
    display: inline-block;
    width: 15px;
    height: 16px;
    background: url(../../assets/imgs/icon-small.png) no-repeat -36px;
    vertical-align: -3px;
  }
  .phone-caozuo {
    width: 400px;
    margin: 30px 100px;
    color: #666;
  }
  .phone-caozuo .caozuo {
    margin-bottom: 20px;
  }
  .phone-caozuo .caozuo .caozuo-left {
    display: inline-block;
    width: 120px;
    text-align: right;
    padding-right: 10px;
    font-size: 14px;
  }
  .phone-caozuo .caozuo .caozuo-right {
    display: inline-block;
    position: relative;
    font-size: 14px;
  }
  .phone-caozuo .caozuo .caozuo-right .yanzhengma {
    width: 240px;
    height: 18px;
    padding: 4px 0;
    font-size: 13px;
    line-height: 18px;
    color: #666;
  }
  .phone-caozuo .caozuo .caozuo-right .getyan {
    position: absolute;
    right: 15px;
    top: 6px;
    cursor: pointer;
    background: #fff;
    border: 0;
    font-size: 14px;
    outline: none;
  }

</style>






// WEBPACK FOOTER //
// src/pages/user/user4.vue